/* Lenis smooth scroll — the foundation of the animation layer (DESIGN.md §6).
   Follows the reference's init (`new Lenis()`), driven by a rAF loop (they use
   gsap.ticker; we don't ship GSAP, so this is the standard equivalent — same
   lenis.raf(time) call). One deliberate tweak off their defaults: lerp 0.12
   instead of 0.10, so a change of scroll direction catches up a touch faster
   (Mats found the default just slightly laggy on reversal). Keep it subtle —
   higher values start to feel abrupt and lose the calm glide.

   Overlay interplay: the menu / cart / signup lock the page by setting
   `overflow: hidden` on <html> (and restore '' on close, with their own
   cross-overlay guards). Rather than teaching all three about Lenis, we watch
   that one style attribute here and stop/start Lenis with it — the reference
   does the same thing explicitly (lenis.stop() in openNav).

   Decorates, never gates: reduced-motion users keep native scrolling, and if
   Lenis fails to load the page scrolls natively — nothing else depends on it. */
(function () {
  if (typeof Lenis === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var lenis = new Lenis({ lerp: 0.12 });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  /* pause while any overlay holds the scroll lock — the lock may already be
     on at init (the preloader gate sets it from <head> before we run) */
  var locked = document.documentElement.style.overflow === 'hidden';
  if (locked) lenis.stop();
  new MutationObserver(function () {
    var isLocked = document.documentElement.style.overflow === 'hidden';
    if (isLocked === locked) return;
    locked = isLocked;
    if (locked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });

  window.OnniLenis = lenis;
})();
